import React from 'react';
import BaseTable from './BaseTable';
import SingleAddTableBody from './tbody/SingleAddTableBoby';
import { SortOrder } from '../../types/sort/sort';

interface Header {
  label: string;
  sortable: boolean;
  sortKey: string;
  width: string;
}

interface HasId {
  id: number;
}

/** 構造的Ref（非推奨型を使わない） */
type DivRef = { current: HTMLDivElement | null };

interface SingleAddTableProps<T extends HasId> {
  headers: ReadonlyArray<Header>;
  items: T[];
  renderItem: (item: T) => React.JSX.Element;
  addItem?: () => React.JSX.Element;
  isAdding?: boolean;
  setIsAdding?: React.Dispatch<React.SetStateAction<boolean>>;
  editItem: () => React.JSX.Element;
  editingId: number | null;
  actionable: boolean;
  onSort?: (sortKey: string) => void;
  sortOrder?: SortOrder;
  activeSortColumn?: string;

  /** 親から表のスクロール要素を参照するためのref（構造的Ref） */
  scrollContainerRef?: DivRef;
  headerRef?: React.RefObject<HTMLDivElement | null>; // 高さ計算用
  footerRef?: React.RefObject<HTMLDivElement | null>; // 高さ計算用
}

const SingleAddTable = <T extends HasId>({
  headers,
  items,
  renderItem,
  addItem,
  isAdding,
  setIsAdding,
  editItem,
  editingId,
  actionable,
  onSort,
  sortOrder,
  activeSortColumn,
  scrollContainerRef,
  headerRef,
  footerRef,
}: SingleAddTableProps<T>) => {
  return (
    <>
      {/* テーブル全体の横スクロール要素（親が参照する） */}
      <div
        className="single-add-table-scroll"
        style={{ overflowX: 'auto' }}
        ref={scrollContainerRef as unknown as React.Ref<HTMLDivElement>}
      >
        <BaseTable
          headers={headers}
          actionable={actionable}
          onSort={onSort}
          sortOrder={sortOrder}
          activeSortColumn={activeSortColumn}
          headerRef={headerRef}
          footerRef={footerRef}
        >
          <SingleAddTableBody<T>
            items={items}
            renderItem={renderItem}
            addItem={addItem}
            isAdding={isAdding}
            setIsAdding={setIsAdding}
            editItem={editItem}
            editingId={editingId}
          />
        </BaseTable>
      </div>
    </>
  );
};

export default SingleAddTable;
